/**
 * @generated SignedSource<<b9788b459c3eb34cabe7cc254e234501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FetchJiraServerOAuthUrlInput = {
  jiraServerUrl?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type fetchJiraServerOauthUrlMutation$variables = {
  input: FetchJiraServerOAuthUrlInput;
};
export type fetchJiraServerOauthUrlMutation$data = {
  readonly fetchJiraServerOAuthUrl: {
    readonly url: string | null;
    readonly token: string | null;
    readonly token_secret: string | null;
    readonly errors: string | null;
  } | null;
};
export type fetchJiraServerOauthUrlMutation = {
  variables: fetchJiraServerOauthUrlMutation$variables;
  response: fetchJiraServerOauthUrlMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FetchJiraServerOAuthUrlPayload",
    "kind": "LinkedField",
    "name": "fetchJiraServerOAuthUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token_secret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de19343b9831dc624af88bdaa2f71dd8",
    "id": null,
    "metadata": {},
    "name": "fetchJiraServerOauthUrlMutation",
    "operationKind": "mutation",
    "text": "mutation fetchJiraServerOauthUrlMutation(\n  $input: FetchJiraServerOAuthUrlInput!\n) {\n  fetchJiraServerOAuthUrl(input: $input) {\n    url\n    token\n    token_secret\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "64d67d800f11a98e9ba92d32022c74fa";

export default node;
